import { FolderDetail } from "../../../../domain/Folder/Folder"
import Forms from "../../../../domain/Form/Forms"
import { Pagination } from "../../pagination"
import FolderComponentAsBlock from "../FolderComponent/FolderComponentAsBlock"


interface Props {
  folders: FolderDetail[]
  totalItems: number
  itemsPerPage: number
  handleDeleteFolder: (id: string) => void
  type: string | null
  forms: Forms[]
  state: string | null
}

const FoldersDataListAsBlock = ({ folders, totalItems, itemsPerPage, handleDeleteFolder, type, forms, state }: Props): JSX.Element => {

  return (
    <>
      {folders?.map((folder) => (
        <FolderComponentAsBlock FolderDetail={folder} key={folder.id} forms={forms} handleDeleteFolder={handleDeleteFolder} type={type} state={state} />
      ))}
      <Pagination itemsPerPage={itemsPerPage} totalItems={totalItems} />
    </>
  );
};

export default FoldersDataListAsBlock;
